<div class="space-y-2 p-3 border border-divider rounded-lg bg-card shadow-sm">
    <h3 class="text-base font-semibold text-default mb-3">Social Media Links</h3>
    <p class="text-sm text-secondary mb-3">
        Enter the full URL for each social media profile you want to display.
    </p>

    <div class="space-y-4">
        <div *ngFor="let social of internalSocials; trackBy: trackByPlatform"
             class="grid grid-cols-1 sm:grid-cols-[minmax(120px,max-content)_1fr] gap-x-4 gap-y-1 items-center">

            <div class="flex items-center space-x-2">
                <mat-icon [svgIcon]="social.platform.trim().toLowerCase()" class="text-secondary"></mat-icon>
                <span class="text-sm font-medium text-default">{{ social.name }}</span>
            </div>

            <mat-form-field class="w-full" appearance="outline">
                <input matInput
                       [name]="social.platform"
                       [placeholder]="social.placeholder"
                       [(ngModel)]="social.url"
                       (ngModelChange)="onLinkChange()"
                       [disabled]="isDisabled || social.readOnly">
            </mat-form-field>

        </div>
    </div>
</div>
